import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MUNILY_INPUT_PREVIEW_DEFAULTS } from './input-preview.types';

@Component({
  selector: 'common-input-preview',
  templateUrl: './input-preview.component.html',
  styleUrls: ['./input-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputPreviewComponent {
  @Input() value: string = MUNILY_INPUT_PREVIEW_DEFAULTS.value;
  @Input() label: string = MUNILY_INPUT_PREVIEW_DEFAULTS.label;
  @Input() showLabel: boolean = MUNILY_INPUT_PREVIEW_DEFAULTS.showLabel;
  @Input() showLeadingIcon: boolean = MUNILY_INPUT_PREVIEW_DEFAULTS.showLeadingIcon;
  @Input() leadingIcon: string = MUNILY_INPUT_PREVIEW_DEFAULTS.leadingIcon;
  @Input() showEditIcon: boolean = MUNILY_INPUT_PREVIEW_DEFAULTS.showEditIcon;
  @Input() borderless: boolean = MUNILY_INPUT_PREVIEW_DEFAULTS.borderless;
  /** When true, clicking the row emits `edit` (even if `showEditIcon` is false). */
  @Input() clickable: boolean = MUNILY_INPUT_PREVIEW_DEFAULTS.clickable;

  @Output() edit = new EventEmitter<void>();

  onEdit(): void {
    this.edit.emit();
  }

  onClick(): void {
    if (!this.clickable) return;
    this.onEdit();
  }
}
